import { ImportJobStore } from "@domain/stores/ImportJobStore";
import { create } from "zustand";

type InitialState = Pick<ImportJobStore, "importJob">;

const initialState: InitialState = {
  importJob: null,
};

const importJobStore = create<ImportJobStore>((set) => ({
  ...initialState,
  updateImportJob(newImportJob) {
    set((state) => {
      return {
        ...state,
        importJob: newImportJob,
      };
    });
  },
  clear: () => {
    set((state) => {
      return {
        ...state,
        ...initialState,
      };
    });
  },
}));

export default importJobStore;
